import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { CaseManagementService } from '../../../services/caseManagement.service';
import demoData from '../../../../assets/data/demoData.json';
import { forkJoin } from 'rxjs';
import { ViewNotesComponent } from '../view-notes/view-notes.component';
import { ViewAttachmentComponent } from '../view-attachment/view-attachment.component';

@Component({
  selector: 'view-detail-modal',
  templateUrl: './view-detail-modal.component.html',
  styleUrls: ['./view-detail-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ViewDetailModalComponent implements OnInit {

  woDowntime: any;
  woRoViewDetails: any;
  loading: boolean;
  woKey: number;
  woHierarchyDetails: any;
  customerName: String = '';
  subCustomerName: String = '';
  divisionName: String = '';
  shipToName: String = '';
  timeZone: String;
  woRODetails: any = [];
  roStatus: any;
  serviceTypeId: number;
  woROService: any;

  constructor(
    private dialogRef: MatDialogRef<ViewDetailModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    private caseManagementService: CaseManagementService,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    this.caseManagementService.setWorkOrderKey(this.data.woNumber);
    this.woKey = this.data.woNumber;
    this.timeZone = sessionStorage.getItem('customerTimezone');

    if (sessionStorage.getItem('isDemo') == 'yes') {
      const demoWOData = JSON.parse(sessionStorage.getItem('caseSummaryReport'));
      demoData.woRoViewDetails.TSQvc255ReferenceNumber = demoWOData.referenceNumber;
      demoData.woRoViewDetails.WO_Submitted = demoWOData.WoSubmitDate;
      demoData.woRoViewDetails.WO_CallEntryStart = demoWOData.WoSubmitDate;
      demoData.woRoViewDetails.WO_MaintDwnTimeStart = demoWOData.WoSubmitDate;
      demoData.woRoViewDetails.TSQvc255PONumber = demoWOData.ponumber;
      demoData.woRoViewDetails.ServiceRequired = demoWOData.serviceName;
      this.woRoViewDetails = demoData.woRoViewDetails;
      this.woRODetails = demoData.woRODetails;
      this.woDowntime = demoData.woDowntime;
      this.woHierarchyDetails = demoData.woHierarchyDetails;
      this.customerName = sessionStorage.getItem('companyName');
      this.subCustomerName = 'demo sub customer';
      this.divisionName = 'demo division';
      this.shipToName = 'demo ship to';
    } else {
      this.setViewDetailsPopupData();
    }
  }

  setViewDetailsPopupData() {
    const woroViewDetailsReq = this.caseManagementService.getWoRoViewDetails(this.woKey);
    const calWODowntimeReq = this.caseManagementService.getCalculateWODowntime(this.woKey);
    const woHierarchyDetailsReq = this.caseManagementService.getWorkOrderHierarchyDetails(this.woKey);
    const woroDetailsReq = this.caseManagementService.getWORODetails(this.woKey)

    this.loading = true;
    forkJoin([woroViewDetailsReq, calWODowntimeReq, woHierarchyDetailsReq, woroDetailsReq]).subscribe(result => {
      this.loading = false;
      this.woRoViewDetails = result[0][0];
      this.woDowntime = result[1][0];
      this.woHierarchyDetails = result[2];
      this.woRODetails = result[3];

      this.customerName = this.woHierarchyDetails.customerName;
      if (this.woHierarchyDetails.subCustomerName != null) {
        this.subCustomerName = this.woHierarchyDetails.subCustomerName;
      }
      if (this.woHierarchyDetails.divisionName != null) {
        this.divisionName = this.woHierarchyDetails.divisionName;
      }
      if (this.woHierarchyDetails.shipToKey != 0 && this.woHierarchyDetails.shipToKey != null && this.woHierarchyDetails.shipToKey != '') {
        if (this.woHierarchyDetails.locationId != null || this.woHierarchyDetails.locationId != '')
          this.shipToName = this.shipToName + this.woHierarchyDetails.locationId.toString() + ' - ';
        if (this.woHierarchyDetails.shipToName != null || this.woHierarchyDetails.shipToName != '')
          this.shipToName = this.shipToName + this.woHierarchyDetails.shipToName.toString() + ' - ';
        if (this.woHierarchyDetails.locationName != null || this.woHierarchyDetails.locationName != '')
          this.shipToName = this.shipToName + this.woHierarchyDetails.locationName.toString() + ' - ';
        if (this.woHierarchyDetails.locationCity != null || this.woHierarchyDetails.locationCity != '')
          this.shipToName = this.shipToName + this.woHierarchyDetails.locationCity.toString() + ' - ';
        if (this.woHierarchyDetails.locationState != null || this.woHierarchyDetails.locationState != '')
          this.shipToName = this.shipToName + this.woHierarchyDetails.locationState.toString() + ' - ';
        this.shipToName = this.shipToName.substring(0, this.shipToName.length - 3)
      }
    }, (error) => {
      this.loading = false;
      console.error('ViewDetailModalComponent_setViewDetailsPopupData', error);
    });
  }

  viewNotes() {
    this.dialog.open(ViewNotesComponent, {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      height: '90%',
      maxHeight: '90%',
      width: '60%',
      position: {
        top: '5%',
      }
    });
  }

  viewAttachment() {
    this.dialog.open(ViewAttachmentComponent, {
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      width: '70%',
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
